export default __webpack_public_path__ + "static/media/ananya.4e982ace.png";